import React, { useEffect } from "react";
import Footer from "../components/footer";
import StudentHeader from "../components/studentHeader";
import SideBar from "../components/sidebar/sidebar";

import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  STUDENT_ROLE,
  STUENT_JOURNEY_URL,
  TEACHER_JOURNEY_URL,
  studentRouteConfig,
} from "../constants";

const StudentLayout = ({ children }) => {
  const currentUser = useSelector((state) => state?.auth?.user);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("line 20 currentUser", currentUser);
    if (currentUser === null) {
      navigate("/");
    } else if (currentUser?.role && currentUser?.role !== STUDENT_ROLE) {
      navigate(TEACHER_JOURNEY_URL);
    }

    // below line is for hide warning of passing handlers in dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  return (
    <div>
      <StudentHeader />
      <div className="d-flex">
        {currentUser?.role === STUDENT_ROLE ? (
          <>
          {console.log("line 35 currentUser?.role", currentUser?.role)}
          <SideBar routeConfig={studentRouteConfig} />
          </>
        ) : (
          ""
        )}
        <div
          className="container-fluid p-0"
          // style={{backgroundColor: "#eeeeee"}}
        >
          <main>
            <div className="main_standard" style={{ minHeight: "90vh" }}>
              {children}
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default StudentLayout;
